<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Sistem tidak akan dapat menambahkan Panel ID / Username yang
          sama.<br />Untuk Cash Market (CM), cukup isi kolom Panel ID.<br />Untuk
          White Label (WL) / Nexus, kolom username disamakan dengan Panel ID.</FormNote
        >

        <div class="rounded mb-6 bg-red-500" v-if="readOnly">
          <p class="text-sm p-4 text-white">
            Note: ASSET, USERNAME dan PANEL ID account ini TIDAK DAPAT DIRUBAH
            karena sudah ada transaksi sebelumnya.<br>Jika ingin memindahkan
            account ke member lain, gunakan fitur transfer account.
          </p>
        </div>

        <FormRow class="mb-4" :required="true">
          <template #label>Asset</template>
          <template #field>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.asset.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Search asset"
              :showLabels="false"
              @select="getListProduct"
              :disabled="readOnly"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.asset.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.asset.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Product</template>
          <template #field>
            <multiselect
              v-model="formData.product"
              :options="listProduct"
              :loading="listProductLoading"
              :close-on-select="true"
              :hide-selected="false"
              :class="$v.formData.product.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="name_master"
              tag-placeholder="Press enter to choose"
              placeholder="Search product"
              :showLabels="false"
              :allow-empty="false"
            >
              <template #noOptions v-if="formData.asset"
                >No products found for Asset
                {{ formData.asset.name }}.</template
              >
              <template #noOptions v-else>Please select asset first.</template>
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.product.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.product.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #help
            >Only products for selected asset will be shown.</template
          >
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Panel ID</template>
          <template #field>
            <input
                :class="{
                'form__input--error':
                  $v.formData.panel_id.$error && formSubmitted,
              }"
                type="text"
                class="form__input"
                placeholder="Panel ID"
                v-model="formData.panel_id"
                :readonly="readOnly"
                :disabled="readOnly"
            />
            <div
                class="form-error"
                v-if="$v.formData.panel_id.$error && formSubmitted"
            >
              <span
                  class="form-error__text"
                  v-if="!$v.formData.panel_id.required"
              >This field is required.</span
              >
              <span
                  class="form-error__text"
                  v-if="!$v.formData.panel_id.alphaNumUnderscore"
              >Only letters, numbers and underscores are allowed.</span
              >
            </div>
          </template>
        </FormRow>


        <FormRow class="mb-4">
          <template #label>Username</template>
          <template #field>
            <input
              type="text"
              class="form__input"
              placeholder="Username"
              v-model="formData.username"
              :readonly="readOnly"
              :disabled="readOnly"
            />
            <div
              class="form-error"
              v-if="$v.formData.username.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.username.alphaNumUnderscore"
                >Only letters, numbers and underscores are allowed.</span
              >
            </div>
          </template>
          <template #help v-if="formCreate"
          >Only for White Label (WL) / Nexus. Username must be the same as
            Panel ID.</template
          >
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Account Note</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Account Note"
              rows="5"
              v-model="formData.note"
            ></textarea>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>Current balance</template>
          <template #field>
            <input
              readonly
              disabled
              type="text"
              class="form__input bg-gray-400 bg-opacity-25"
              :value="currentBalance"
            />

            <button
              class="
                border-red-500
                button
                border border-solid
                hover:bg-red-500
                hover:text-white
                transition-all
                duration-200
                mt-2
                text-left text-red-500
              "
              @click="toggleChangeBalance"
              type="button"
            >
              <span class="text-xs"
                ><font-awesome-icon :icon="['fas', 'coins']" />
                {{ changeBalanceText }}</span
              >
            </button>
          </template>
        </FormRow>

        <FormRow
          class="mb-4"
          :required="true"
          v-if="!formCreate && changeBalance"
        >
          <template #label>New balance</template>
          <template #field>
            <input
              type="text"
              class="form__input"
              v-model="formData.new_balance"
              placeholder="New balance adjustment"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
              @blur="checkBalance"
            />
            <div
              class="form-error"
              v-if="$v.formData.new_balance.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.new_balance.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow
          class="mb-4"
          :required="true"
          v-if="!formCreate && changeBalance"
        >
          <template #label>Adjustment note</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Adjustment note"
              rows="5"
              v-model="formData.new_balance_note"
            ></textarea>
            <div
              class="form-error"
              v-if="$v.formData.new_balance_note.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.new_balance_note.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #help>Reason for balance adjustment</template>
        </FormRow>

        <FormRow
          class="mb-4"
          v-if="userCan('unlock.member-account') && formData.readonly"
        >
          <template #label></template>
          <template #field>
            <input
              type="text"
              class="form__input mb-2"
              v-model="formData.ticket"
              placeholder="Request Ticket Number"
            />

            <BaseButton
              type="button"
              buttonClass="secondary"
              @click="unlockReadOnly"
              >Unlock Readonly</BaseButton
            ></template
          >
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />

        <FormRow
          class="mt-4 border-t pt-4"
          v-if="userCan('unlock.member-account') && formData.ticket_history"
        >
          <template #label>Ticket History</template>
          <template #field>
            <ul class="list-inside">
              <li
                class="text-sm"
                v-for="ticket in formData.ticket_history"
                :id="ticket"
                :key="ticket"
              >
                <router-link
                class="link"
                target="_blank"
                  :to="{
                    name: 'SupportTicketView',
                    params: { id: ticket },
                  }"
                  >{{ ticket }}</router-link
                >
              </li>
            </ul>
          </template>
        </FormRow>
      </template>

      <template #footer>
        <div
          class="bg-red-600 text-white p-6 mb-4 text-sm font-medium"
          v-if="updateMsg"
        >
          Note: {{ updateMsg }}
        </div>

        <FormRow class="mb-4" :required="true" v-if="updateMsg">
          <template #label>Reason for Update</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Reason for Update"
              rows="5"
              v-model="formData.reason"
            ></textarea>
            <div
              class="form-error"
              v-if="$v.formData.reason.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.reason.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div class="ml-4">
              or
              <router-link :to="{ name: 'MemberList' }" class="link ml-2"
                >Back to List Members</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import Multiselect from "vue-multiselect";
import { CurrencyDirective } from "vue-currency-input";
import { helpers, required, requiredIf } from "vuelidate/lib/validators";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { getListProductOptionsMixin } from "@/mixins/getListProductOptionsMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";

const alphaNumUnderscore = helpers.regex(
  "alphaNumUnderscore",
  /^[a-zA-Z\d_]*$/
);

export default {
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [getListAssetMixin, getListProductOptionsMixin, submitFormMixin],
  components: {
    Multiselect,
  },
  validations: {
    formData: {
      asset: { required },
      username: { alphaNumUnderscore },
      panel_id: { alphaNumUnderscore, required },
      product: { required },
      new_balance: {
        required: requiredIf(function () {
          return this.changeBalance;
        }),
      },
      new_balance_note: {
        required: requiredIf(function () {
          return this.changeBalance;
        }),
      },
      reason: {
        required: requiredIf(function () {
          return this.formData.force_update == 1;
        }),
      },
    },
  },
  data: () => {
    return {
      updateMsg: "",
      listAccount: [],
      listAccountLoading: true,

      listAsset: [],
      listAssetLoading: true,

      listProduct: [],
      listProductLoading: false,

      memberData: {},
      memberDataLoading: true,

      formData: {
        panel_id: "",
        force_update: 0,
      },

      hasTransaction: false,
      readOnly: false,
      member_account: {},
      currentBalance: 0,
      changeBalance: false,
      changeBalanceText: "Change Balance",
    };
  },
  created() {
    this.getListAsset();
  },
  watch: {
    "$route.params.id": function (id) {
      if (id) {
        this.formCreate = false;
        this.fetchData(id);
      } else {
        this.formCreate = true;
        this.formData = {
          panel_id: "",
          username: "",
          asset: null,
          product: null,
          note: "",
        };
        this.hasTransaction = false;
        this.readOnly = false;
        this.listProduct = [];
      }
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint(this.$route)
        : "/" +
            this.$route.meta.endpoint(this.$route) +
            "/" +
            this.formData.uuid;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint(this.$route);
    },
  },
  methods: {
    getListProduct(asset, selectedProduct) {
      this.listProductLoading = true;

      if (!selectedProduct) {
        if (this.formData.product) {
          this.formData.product = null;
        } else if (this.formData.accounts) {
          this.formData.accounts.product = null;
        }
      }

      this.$http
        .get(process.env.VUE_APP_API_URL + "/product?asset_id=" + asset.id)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listProduct = response.data;

              if (selectedProduct) {
                this.formData.product = selectedProduct;
                this.formReady = true;
              } else {
                if (response.data.length == 1) {
                  this.formData.product = response.data[0];
                }
              }
            }
          }
        })
        .finally(() => {
          this.listProductLoading = false;
        });
    },
    unlockReadOnly() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        const url = process.env.VUE_APP_API_URL + this.submitUrl;

        this.formData.unlock = 1;

        this.$http({
          method: "patch",
          url: url,
          data: { account: this.formData },
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push(
                {
                  name: "MemberProfile",
                  params: { memberId: this.$route.params.memberId },
                },
                () => {
                  this.$swal({
                    position: "bottom-end",
                    showConfirmButton: false,
                    toast: true,
                    timer: 5000,
                    timerProgressBar: true,
                    title: res.data.message,
                    icon: "success",
                  });
                }
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                this.updateMsg = error.response.data.data.member_bank_account;

                this.formSubmitted = false;
                this.formLoading = false;
                this.formData.force_update = 1;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
    toggleChangeBalance() {
      if (this.changeBalance) {
        this.changeBalance = false;
        delete this.formData.new_balance;
        delete this.formData.new_balance_note;
        this.changeBalanceText = "Change Balance";
      } else {
        this.changeBalance = true;
        this.formData.new_balance = this.formData.balance;
        this.changeBalanceText = "Cancel";
      }
    },
    checkBalance() {
      if (!this.formData.balance) this.formData.balance = "0.00";
    },
    dateformat(date) {
      return this.moment(date).format("DD MMM YYYY | HH:mm");
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };

            this.currentBalance = data.balance;

            if (data.asset.id) {
              this.getListProduct(data.asset, data.product);
            } else {
              this.formData.product = null;
            }

            // this.hasTransaction = data.transaction;
            this.readOnly = data.readonly;

            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        const method = this.formCreate ? "post" : "patch";
        const url = process.env.VUE_APP_API_URL + this.submitUrl;

        this.$http({
          method: method,
          url: url,
          data: {
            account: this.formData,
            new_balance: this.formData.new_balance,
            new_balance_note: this.formData.new_balance_note,
          },
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push(
                {
                  name: "MemberProfile",
                  params: { memberId: this.$route.params.memberId },
                },
                () => {
                  this.$swal({
                    position: "bottom-end",
                    showConfirmButton: false,
                    toast: true,
                    timer: 5000,
                    timerProgressBar: true,
                    title: res.data.message,
                    icon: "success",
                  });
                }
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                this.updateMsg = error.response.data.data.member_account;

                this.formSubmitted = false;
                this.formLoading = false;
                this.formData.force_update = 1;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  },
};
</script>
